import React from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { RootState } from 'redux/schemas';

// components
import NvSwitch from 'shared/components/inputs/nv-switch';
import { RolePlayInteractionMode } from 'redux/schemas/models/ai-role-play';
import { config } from '@config/pendo.config.json';
import { getFlatCourseAliases } from 'redux/selectors/course';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import VoiceList from './voice-list';

const AICharacterVoice = () => {
  const { setValue, watch } = useFormContext();
  const interactionMode = watch('interactionMode');
  const isVoiceEnabled = interactionMode === RolePlayInteractionMode.VOICE;
  const params = useLecturePageParams();
  const courseAliases = useSelector((state: RootState) => getFlatCourseAliases(state, params.catalogId));

  return (
    <div className='mt-6'>
      <div className='d-flex align-items-center'>
        <div className='bold text-large-body lh-25 mr-2'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_VOICE.TITLE()}
        </div>
        <NvSwitch
          className='switch'
          checked={isVoiceEnabled}
          onChange={(checked) => setValue(
            'interactionMode',
            checked ? RolePlayInteractionMode.VOICE : RolePlayInteractionMode.TEXT,
            { shouldDirty: true },
          )}
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_VOICE.TITLE()}
          data-qa={config.pendo.activities.aiRolePlay.configModal.editInteractionModeToggle}
        />
      </div>
      <div className='mt-1 text-gray-1 text-large-body lh-25'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_VOICE.DESCRIPTION(courseAliases)}
      </div>

      {isVoiceEnabled && <VoiceList />}
    </div>
  );
};

export default AICharacterVoice;
